import styled from "styled-components";

export const FinancialAnalysisContainer = styled.div`
  width: 400px;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  h1 {
    color: #0a2b5c;
    font-size: 12px;
    font-family: 'Roboto', sans-serif;
    text-transform: uppercase;
  }

  .graphic {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 5px;

    .graphic-text {
      text-align: end;
      min-width: 155px;
      font-size: 13px;
      font-weight: 600;

      p:last-child {
        color: var(--primary-pure);
      }

      &:last-child {
        text-align: start;
      }
    }

    .graphic-content {
      width: 100%;
      margin: 1px;
      display: flex;
      flex-direction: column;
      align-items: center;
      
      .doughnut {
        width: 100% !important;
        height: 100% !important;
        min-width: 103px;
        min-height: 103px;
        max-width: 240px;
        max-height: 240px;
      }
    }
  }

  .custom-legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    max-width: 420px;
    margin-top: 12px;
    padding: 0 8px;
    gap: 8px;
    font-size: 12px;

    .legend-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 6px 14px;
      border-radius: 999px;
      font-weight: 600;
    }

    .legend-color-box {
      width: 14px;
      height: 14px;
      border-radius: 4px;
      border: 1px solid #D4DEED;
    }

    .legend-text {
      white-space: nowrap;
    }
  }
`;
